import { useState } from "react";
import { toast } from "sonner";
import { UploadCloud, X, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { absUrl } from "@/lib/helpers";

export default function ImageUpload({ value, onChange, label = "Gambar", testid }) {
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Gambar berhasil diunggah");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Gagal mengunggah gambar");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <p className="mb-1.5 text-sm font-medium">{label}</p>
      {value ? (
        <div className="relative inline-block">
          <img src={absUrl(value)} alt={label} className="h-24 w-24 rounded-xl object-cover ring-1 ring-border" />
          <button type="button" onClick={() => onChange("")} className="absolute -right-2 -top-2 rounded-full bg-destructive p-1 text-white"><X className="h-3.5 w-3.5" /></button>
        </div>
      ) : (
        <label data-testid={testid} className="flex h-24 w-24 cursor-pointer flex-col items-center justify-center gap-1 rounded-xl border border-dashed border-border text-muted-foreground hover:bg-secondary">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <UploadCloud className="h-5 w-5" />}
          <span className="text-[10px]">{busy ? "Mengunggah" : "Unggah"}</span>
          <input type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={handle} disabled={busy} />
        </label>
      )}
    </div>
  );
}
